import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '../components/ui/accordion';
import { FAQS } from '../data';

export default function FAQ() {
  return (
    <div data-testid="faq-page" className="pt-32 pb-24 bg-[#0a0a0a] text-white min-h-screen">
      <div className="max-w-4xl mx-auto px-6 md:px-10">
        <span className="pill mb-4">FAQ</span>
        <h1 className="font-display font-light text-5xl sm:text-6xl tracking-tighter">Common questions, clear answers.</h1>

        <Accordion type="single" collapsible className="mt-12 space-y-3">
          {FAQS.map((f, i) => (
            <AccordionItem
              key={i}
              value={`item-${i}`}
              data-testid={`faq-item-${i}`}
              className="bg-[#141414] border border-white/5 rounded-2xl px-6 data-[state=open]:border-blue-500/40 transition-colors"
            >
              <AccordionTrigger className="text-left text-base md:text-lg font-medium hover:no-underline py-5">
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="text-zinc-400 leading-relaxed pb-5">
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </div>
  );
}
